import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import './components/MapboxGL/mapbox-gl.css'
import './index.css'
import App from './App'
import { Provider } from 'react-redux'
import { AuthProvider } from './context/AuthProvider'
import { store } from './redux/store'
import { CssBaseline, ThemeProvider } from '@mui/material'
import theme from './theme'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <Provider store={store}>
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AuthProvider>
          <App />
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  </Provider>
)
